import React from 'react';
import { TaskStatusModal } from './TaskStatusModal';

interface MarkInProgressModalProps {
  visible: boolean;
  onDismiss: () => void;
  onConfirm: () => void;
}

export const MarkInProgressModal: React.FC<MarkInProgressModalProps> = (props) => {
  return <TaskStatusModal {...props} status="in-progress" />;
};
